import React from 'react';
import './quantia.css';

/**
 * Tarjeta Quantia con variantes default | featured (purple) | dark.
 *
 * Props:
 *  - variant:  'default' | 'featured' | 'dark'
 *  - icon:     nodo opcional (emoji/icono) que se muestra en una caja coloreada
 *  - iconTone: 'purple' (default) | 'lime' | 'dark'
 *  - tag:      string corto uppercase (ej. "BIM", "Destacado")
 *  - title:    string con el título
 *  - children: cuerpo y footer libres
 *  - onClick:  hace toda la tarjeta interactiva si se proporciona
 *  - sx:       estilos inline adicionales (CSSProperties)
 */
const QuantiaCard = ({
  variant = 'default',
  icon,
  iconTone = 'purple',
  tag,
  title,
  children,
  onClick,
  sx = {},
  className = '',
}) => {
  const interactive = typeof onClick === 'function';

  return (
    <article
      className={`qa-card qa-card--${variant} ${interactive ? 'qa-card--interactive' : ''} ${className}`}
      style={sx}
      onClick={onClick}
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      onKeyDown={
        interactive
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(e);
              }
            }
          : undefined
      }
    >
      {icon && (
        <div className={`qa-card__icon qa-card__icon--${iconTone}`}>
          {icon}
        </div>
      )}
      {tag && <p className="qa-card__tag">{tag}</p>}
      {title && <h3 className="qa-card__title">{title}</h3>}
      <div className="qa-card__body">{children}</div>
    </article>
  );
};

export default QuantiaCard;
